module.exports = "/images/et.svg";